export default __webpack_public_path__ + "static/En_ELIB_EzyMedical_Declaration-bfb85cc53b8c7d7462a7b82828734a2a.pdf";